module.exports = __webpack_public_path__ + "img/icon-speed-0.9402dafa.svg";